import { useEffect, useMemo, useState } from 'react';

import { useQueryParam, withDefault } from 'use-query-params';

import type { GridSortModel } from '@packages/fenrir/components';
import { DataGridProSortParam } from '@packages/utils/use-query-params/data-grid-pro-sort-param/data-grid-pro-sort-param';

interface UseSortParamsOptions {
  paramName?: string;
  defaultSort: GridSortModel;
  supportedSortFields?: string[];
}

export const useSortParams = ({
  paramName = 'sort',
  defaultSort,
  supportedSortFields,
}: UseSortParamsOptions) => {
  const [queryParamSortModel, setQueryParamSortModel] = useQueryParam(
    paramName,
    withDefault(DataGridProSortParam, defaultSort),
  );
  const [sortModel, setSortModel] = useState<GridSortModel>(() => {
    const validatedSort = supportedSortFields
      ? queryParamSortModel.filter(({ field }) =>
          supportedSortFields.includes(field),
        )
      : queryParamSortModel;

    return validatedSort;
  });

  useEffect(() => {
    setQueryParamSortModel(sortModel);
  }, [sortModel, setQueryParamSortModel]);

  const sortParams = useMemo(() => {
    const sort: string[] = [];
    sortModel.forEach((s) =>
      sort.push(s.sort === 'desc' ? `-${s.field}` : s.field),
    );
    const sortParamsString = sort.length > 0 ? sort.join(',') : '';
    return sortParamsString ? { sort: [sortParamsString] } : {};
  }, [sortModel]);

  return {
    sortModel,
    setSortModel,
    sortParams,
  };
};
